// extracted by mini-css-extract-plugin
export default {"wrapper":"qC-z","addressLine":"rC-z","fullName":"sC-z"};